import React, { useState, useEffect } from 'react';
import CommonModalForm from '../../components/commonComponent/CommonModalForm';
import { validateForm } from '../../utils/formUtils';
import { toastSuccess, toastError } from '../../utils/alertHelper';
import axios from '../../utils/axiosInstance';
import { FaEdit, FaTrash } from 'react-icons/fa'; 

const BusinessCategory = () => {
  const [businessCategories, setBusinessCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({ name: '' });
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

   const limit = parseInt(process.env.REACT_APP_PAGE_LIMIT || 10); 
  // const limit = 10;

  useEffect(() => {
    fetchBusinessCategory(currentPage, searchQuery);
  }, [currentPage, searchQuery]);

  const fetchBusinessCategory = async (page = 1, search = '') => {
    try {
      const res = await axios.get(`/admin/api/businessCategory?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
      const { businessCategories = [], totalCount = 0 } = res.data;
      setBusinessCategories(businessCategories);
      setTotalPages(Math.ceil(totalCount / limit));
    } catch (err) {
      console.error('Failed to fetch Category:', err);
    }
  };

  const handleSave = async () => {
    const validationErrors = validateForm(formValues, {
      name: { required: true },
    });

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      if (editingId) {
        await axios.put(`/admin/api/businessCategory/${editingId}`, formValues);
        toastSuccess('Category updated successfully!');
      } else {
        await axios.post('/admin/api/businessCategory', formValues);
        toastSuccess('Category added successfully!');
      }
      setCurrentPage(1);  // reset to first page after save
      fetchBusinessCategory(1, searchQuery);
      handleCancel();
    } catch (err) {
      console.error('Failed to save CategoryCategory:', err);
      toastError('Failed to save Category');
    }
  };

  const handleEdit = (businessCategory) => {
    setFormValues({ name: businessCategory.name });
    setEditingId(businessCategory._id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/admin/api/businessCategory/${id}`);
      toastSuccess('Category deleted successfully!');
      setCurrentPage(1);  // reset to first page after delete
      fetchBusinessCategory(1, searchQuery);
    } catch (err) {
      console.error('Failed to delete Category:', err);
      toastError('Failed to delete Category');
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setFormValues({ name: '' });
    setEditingId(null);
    setErrors({});
  };

  return (
    <div className="container mt-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Category</h3>
        <input
          type="text"
          className="form-control w-25"
          placeholder="Search Category..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1); // reset page on search
          }}
        />
      </div>

      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="mb-0">Business Category List</h5>
          <button
            className="btn btn-sm btn-success"
            onClick={() => setShowModal(true)}
          >
            + Add New Category
          </button>
        </div>
       <div className="table-responsive">
        <div className="card-body p-0">
          <table
            className="table table-bordered table-sm mb-0"
          >
            <thead className="table-light">
              <tr>
                <th className="py-1 px-2 w-5">Sr no.</th>
                <th className="py-1 px-2 w-75">Category</th>
                <th className="py-1 px-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {businessCategories.length > 0 ? (
                businessCategories.map((businessCategories, idx) => (
                  <tr key={businessCategories._id}>
                    <td className="py-1 px-2">{(currentPage - 1) * limit + idx + 1}</td>
                    <td className="py-1 px-2">{businessCategories.name}</td>
                    <td className="py-1 px-2">
                      <button
                        className="btn btn-sm me-1 py-0 px-2 fs-6 lh-sm shadow-none border-0 text-primary-custom"
                        title="Edit"
                        onClick={() => handleEdit(businessCategories)}
                      >
                        <FaEdit size={14} />
                      </button>
                      {/* <button
                                              className="btn btn-sm py-0 px-2 fs-6 lh-sm shadow-none border-0 text-danger"
                                              onClick={() => handleDelete(businessCategories._id)}
                                              title="Delete"
                                            >
                                              <FaTrash size={14} />
                                            </button> */}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center py-2">No Category found.</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-end align-items-center gap-2 p-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                &laquo;
              </button>
              {/* Pagination numbers with ellipsis */}
              {Array.from({ length: totalPages }, (_, i) => i + 1)
                .filter(page =>
                  page === 1 ||
                  page === totalPages ||
                  (page >= currentPage - 1 && page <= currentPage + 1)
                )
                .reduce((acc, page, idx, arr) => {
                  if (idx > 0 && page - arr[idx - 1] > 1) {
                    acc.push('ellipsis');
                  }
                  acc.push(page);
                  return acc;
                }, [])
                .map((page, idx) =>
                  page === 'ellipsis' ? (
                    <span key={`ellipsis-${idx}`} className="px-1">...</span>
                  ) : (
                    <button
                      key={page}
                      className={`btn btn-sm page-btn${currentPage === page ? ' active' : ''}`}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  )
                )}
              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                &raquo;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
      
      <CommonModalForm
        visible={showModal}
        title={editingId ? 'Edit BusinessCategory' : 'Add BusinessCategory'}
         fields={[
              { name: 'name', label: 'Category', placeholder: 'Enter Category Name' }
            ]}
        values={formValues}
        errors={errors}
        onChange={setFormValues}
        onSubmit={handleSave}
        onCancel={handleCancel}
        submitLabel={editingId ? 'Update' : 'Save'}
        requiredFields={['name']}
      />
    </div>
  );
};

export default BusinessCategory;
